<template>
    <div v-if="orden_venta">
        <Box  @close="close({})">
            <template #top>Reprogramar Despachos</template>
            <template #center>
                <div class="nj-cols">
                    <div class="nj-card">
                        <div class="nj-subtitle-1">Datos de la orden</div>
                        <div class="nj-cols form c2">
                            <div>
                                <div class="nj-label">Cliente</div>
                                <input type="text" class="nj-text" v-model="cliente" disabled>
                            </div>
                            <div>
                                <div class="nj-label">Fecha y hora</div>
                                <FechaHora :data="fecha_hora" :disabled="true" />
                            </div>
                        </div>
                        <br>
                        <b-table :data="orden_venta.lista_orden_venta_detalle">
                            <template slot-scope="props">
                                <b-table-column label="ID" header-class="is-data">{{ props.row.ovd_id }}</b-table-column>
                                <b-table-column label="Producto" header-class="is-data">{{ props.row.ovd_producto }}</b-table-column>
                                <b-table-column label="Cantidad" header-class="is-data" class="col-1">
                                    <input type="text" class="nj-text nj-text-right" v-model="props.row.ovd_cantidad" disabled>
                                </b-table-column>
                                <b-table-column label="Saldo" header-class="is-data" class="col-1">
                                    <input type="text" class="nj-text nj-text-right" v-model="props.row.ovd_saldo_envio" disabled>
                                </b-table-column>
                                <b-table-column label="Frecuencia (min)" header-class="is-data" class="col-1">
                                    <input type="text" class="nj-text nj-text-right" v-model="props.row.env_frecuencia" :disabled="props.row.ovd_saldo_envio == 0">
                                </b-table-column>
                                <b-table-column label="Opciones" header-class="is-data" class="col-1">
                                    <div class="nj-flx">
                                        <button class="nj-button c-green" @click="agregarEnvio(props.row)" title="Agregar envío" v-if="props.row.ovd_saldo_envio != 0">Programar</button>
                                    </div>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                    <template v-if="lista_envio">
                        <div class="nj-card">
                            <div class="nj-subtitle-1">Despachos</div>
                            <b-table :data="lista_envio">
                                <template slot-scope="props">
                                    <b-table-column label="Producto" header-class="is-info">{{ props.row.ovd_producto }}</b-table-column>
                                    <b-table-column label="Mixer" header-class="is-info" class="col-1">
                                        <select class="nj-select" v-model="props.row.mix_id" @change="seleccionarMixer(props.row.sequence)">
                                            <option value=""></option>
                                            <option v-for="item in mixers" :key="item.mix_id" :value="item.mix_id">{{ item.mix_nombre }} - {{ item.mix_capacidad }}m3</option>
                                        </select>
                                    </b-table-column>
                                    <b-table-column label="Cantidad" header-class="is-info" class="col-1">
                                        <input type="text" class="nj-text nj-text-right" v-model="props.row.env_cantidad" @keyup="calcularTiempos(props.row.sequence)">
                                    </b-table-column>
                                    <b-table-column label="Fecha de entrega" header-class="is-info" style="text-align: center;">
                                        <Fecha :data="props.row.fecha_hora" />
                                    </b-table-column>
                                    <b-table-column label="Hora de entrega" header-class="is-info" style="text-align: center;">
                                        <Hora :data="props.row.fecha_hora" />
                                    </b-table-column>
                                    <b-table-column label="Hora de carguio" header-class="is-info" style="text-align: center;">
                                        <Hora :data="props.row.hora_carguio" />
                                    </b-table-column>
                                    <b-table-column label="Hora de salida" header-class="is-info" style="text-align: center;">
                                        <Hora :data="props.row.hora_salida" @input="calcularTiempos($event)" :id="props.row.sequence" />
                                    </b-table-column>
                                    <b-table-column label="Hora de retorno" header-class="is-info" style="text-align: center;">
                                        <Hora :data="props.row.hora_retorno" />
                                    </b-table-column>
                                    <b-table-column label="Estado" header-class="is-info">
                                        <b-field v-if="props.row.est_id">
                                            <b-tag :class="tagEstado(props.row.est_id)">{{ props.row.est_nombre }}</b-tag>
                                        </b-field>
                                    </b-table-column>
                                    <b-table-column label="Opciones" header-class="is-info" class="col-1">
                                        <div class="nj-flx">
                                            <button class="nj-button icon c-red" v-if="showRemover(props.row)" @click="removerEnvio(props.row.sequence)" title="Remover"><i class="mdi-delete"></i></button>
                                            <button class="nj-button icon c-red" v-if="showCancelarEnvio(props.row)" @click="cancelarEnvio(props.row.env_id)" title="Cancelar"><i class="mdi-close-circle"></i></button>
                                        </div>
                                    </b-table-column>
                                </template>
                            </b-table>
                        </div>
                    </template>
                </div>
            </template>
            <template #bottom>
                <Button icon="calendar" color="green" label="Reprogramar" @click="reprogramar()"></Button>
            </template>
        </Box>
    </div>
</template>

<script>
import { OrdenVentaService, EnvioService } from "../../rest"
import DateTime from "../../util/dateTime"
import Toast from "../../util/toast"
import { AppService, ResponseStatus } from "../../rest"
import Keyboard from "../../util/keyboard"
import { FechaHora, Fecha, Hora, Box, Button } from "../components"

import Confirm from "../../util/confirm"

export default {
    name: "ProgramarEnvios",
    components: {
        FechaHora,
        Fecha,
        Hora,
        Hora,
        Box,
        Button,
    },
    props: {
        ovt_id: {
            type: Number
        }
    },
    data() {
        return {
            sequence: 1,
            orden_venta: null,
            lista_orden_venta_detalle: [],
            lista_envio: [],
            mixers: [],
            estados: [],
        }
    },
    computed: {
        cliente() {
            return `${this.orden_venta.cli_documento_identidad}  ${this.orden_venta.cli_nombre}`
        },
        fecha_hora() {
            return DateTime.convertStringToObject(this.orden_venta.ovt_fecha_entrega)
        }
    },
    methods: {
        obtenerEnvios() {
            const request = {
                envio: {
                    ovt_id: this.ovt_id
                }
            }
            EnvioService.buscar(request).then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.lista_envio = response.data
                    this.lista_envio.forEach(item => {
                        item.sequence = this.sequence
                        this.sequence++
                        item.fecha_hora = DateTime.convertStringToObject(item.env_fecha_hora_envio)
                        item.hora_carguio = DateTime.convertStringToObject(item.env_fecha_hora_carguio)
                        item.hora_salida = DateTime.convertStringToObject(item.env_fecha_hora_salida)
                        item.hora_retorno = DateTime.convertStringToObject(item.env_fecha_hora_retorno)
                    })
                }
                else {
                    Toast.warn(response.message)
                }
            },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        close({
            componente = "reprogramarEnvio",
            status = false,
            renderizar = false,
        }) {
            this.$emit("close", {
                componente,
                status,
                renderizar,
            })
        },
        seleccionarMixer(sequence) {
            this.lista_envio.forEach(item => {
                if (item.sequence == sequence) {
                    const mixer = this.mixers.find(mixer => mixer.mix_id == item.mix_id)
                    if (!mixer) return
                    item.env_cantidad = item.env_cantidad < mixer.mix_capacidad
                        ? item.env_cantidad
                        : mixer.mix_capacidad
                    // solicitando calcular los tiempos
                    this.calcularTiempos(sequence)
                    return
                }
            })
        },
        agregarEnvio(data) {
            this.lista_envio.push({
                sequence: this.sequence,
                ovt_id: this.ovt_id,
                ovd_id: data.ovd_id,
                ovd_producto: data.ovd_producto,
                env_cantidad: data.ovd_cantidad,
                fecha_hora: {
                    day: this.fecha_hora.day,
                    month: this.fecha_hora.month,
                    year: this.fecha_hora.year,
                    hour: this.fecha_hora.hour,
                    min: this.fecha_hora.min,
                },
                fecha_hora_carguio: {
                    day: this.fecha_hora.day,
                    month: this.fecha_hora.month,
                    year: this.fecha_hora.year,
                    hour: "00",
                    min: "00",
                    sec: "00",
                },
                fecha_hora_salida: {
                    day: this.fecha_hora.day,
                    month: this.fecha_hora.month,
                    year: this.fecha_hora.year,
                    hour: "00",
                    min: "00",
                    sec: "00",
                },
                fecha_hora_retorno: {
                    day: this.fecha_hora.day,
                    month: this.fecha_hora.month,
                    year: this.fecha_hora.year,
                    hour: "00",
                    min: "00",
                    sec: "00",
                },
                hora_carguio: {
                    hour: "00",
                    min: "00",
                },
                hora_salida: {
                    hour: "00",
                    min: "00",
                },
                hora_retorno: {
                    hour: "00",
                    min: "00",
                }
            })
            this.sequence++
        },
        removerEnvio(sequence) {
            this.lista_envio = this.lista_envio.filter(item => item.sequence != sequence)
        },
        calcularTiempos(id) {
            // reiniciando la hora_carguio
            this.lista_envio.forEach(item => {
                if (item.sequence == id) {
                    // verificando que el usuario haya ingresado la hora de salida
                    if (
                        item.hora_salida.hour &&
                        item.hora_salida.hour != "00" &&
                        item.hora_salida.hour &&
                        item.hora_salida.hour != "00"
                    ) {
                        // inicializando las variables
                        let _hora_llegada = DateTime.buildDate({
                            year: item.fecha_hora.year,
                            month: item.fecha_hora.month,
                            day: item.fecha_hora.day,
                            hour: item.fecha_hora.hour,
                            min: item.fecha_hora.min,
                            sec: "00",
                        })
                        let _hora_carguio = DateTime.buildDate({
                            year: item.fecha_hora.year,
                            month: item.fecha_hora.month,
                            day: item.fecha_hora.day,
                            hour: item.hora_salida.hour,
                            min: item.hora_salida.min,
                            sec: "00",
                        })
                        let _hora_salida = DateTime.buildDate({
                            year: item.fecha_hora.year,
                            month: item.fecha_hora.month,
                            day: item.fecha_hora.day,
                            hour: item.hora_salida.hour,
                            min: item.hora_salida.min,
                            sec: "00",
                        })
                        let _hora_retorno = DateTime.buildDate({
                            year: item.fecha_hora.year,
                            month: item.fecha_hora.month,
                            day: item.fecha_hora.day,
                            hour: item.fecha_hora.hour,
                            min: item.fecha_hora.min,
                            sec: "00",
                        })
                        if (_hora_llegada > _hora_salida) {
                            // calculando la hora del carguio
                            _hora_carguio.setMinutes(_hora_carguio.getMinutes() - Math.round(item.env_cantidad * 1.5, 0) - 10) // 10 minutos atras adicionales
                            item.hora_carguio = DateTime.splitDateTime(_hora_carguio)
                            // calculando la hora de retorno
                            _hora_retorno.setMinutes((_hora_retorno.getMinutes() + (_hora_llegada.getTime() - _hora_salida.getTime()) / (1000 * 60)) + (item.env_cantidad * 2.5))
                            item.hora_retorno = DateTime.splitDateTime(_hora_retorno)
                        } else {
                            Toast.warn("La hora de salida no puede ser mayor o igual a la hora de entrega")
                        }
                    }
                }
            })
        },
        showRemover(envio) {
            return !envio.env_id
        },
        showCancelarEnvio(envio) {
            // se trata de un envio existente
            let estado = this.estados.find(item => item.est_id == envio.est_id)
            if (estado && estado.est_codigo == "programado") {
                return true
            }
            else {
                return false
            }
        },
        cancelarEnvio(env_id) {
            Confirm.show({
                message: "¿Esta seguro de cancelar el envio?",
                action: () => {
                    EnvioService.cancelarEnvio({
                        envio: {
                            env_id
                        }
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.obtenerEnvios()
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
            })
        },
        reprogramar() {
            const nuevos_envios = this.lista_envio.filter(item => item.env_id == null || item.env_id == undefined)
            nuevos_envios.forEach(item => {
                // carguio
                item.env_fecha_hora_carguio = DateTime.convertObjectToString({
                    day: item.fecha_hora.day,
                    month: item.fecha_hora.month,
                    year: item.fecha_hora.year,
                    hour: item.hora_carguio.hour,
                    min: item.hora_carguio.min,
                })
                // salida
                item.env_fecha_hora_salida = DateTime.convertObjectToString({
                    day: item.fecha_hora.day,
                    month: item.fecha_hora.month,
                    year: item.fecha_hora.year,
                    hour: item.hora_salida.hour,
                    min: item.hora_salida.min,
                })
                // retorno
                item.env_fecha_hora_retorno = DateTime.convertObjectToString({
                    day: item.fecha_hora.day,
                    month: item.fecha_hora.month,
                    year: item.fecha_hora.year,
                    hour: item.hora_retorno.hour,
                    min: item.hora_retorno.min,
                })
                item.env_fecha_hora_envio = DateTime.convertObjectToString(item.fecha_hora)
            })
            const request = {
                lista_envio: nuevos_envios
            }
            EnvioService.registrarEnvios(request).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.close()
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        tagEstado(id) {
            return this.estados.find((item) => item.est_id == id).styles
        },
    },

    mounted() {
        AppService.getData(["mixers", "estados"]).then(response => {
            if (ResponseStatus.isSuccess(response)) {
                this.mixers = response.data.mixers
                this.estados = response.data.estados
                const request = {
                    orden_venta: {
                        ovt_id: this.ovt_id
                    }
                }
                OrdenVentaService.obtener(request).then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.orden_venta = response.data
                        this.orden_venta.lista_orden_venta_detalle.forEach(item => item.env_frecuencia = 60)
                        this.obtenerEnvios()
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
            else {
                Toast.warn(response.message)
            }
        },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped>
.col-1 {
    width: 100% !important;
}

/* @todo  Anotar que tuve q colocar 769px en vez de 768px, averiguar por que */
@media (min-width: 769px) {
    .col-1 {
        width: 100px !important;
    }
}
</style>